export const SUCCESSFUL_DELETE = 'The data was successfully deleted.';
export const SUCCESSFUL_REMOVE = 'The records were successfully removed.';
export const SUCCESSFUL_CREATE = 'The data was successfully created.';
